import { render, staticRenderFns } from "./create-tenant.vue?vue&type=template&id=518f0e34&"
import script from "./create-tenant.vue?vue&type=script&lang=ts&"
export * from "./create-tenant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports